import { ChangeDetectorRef, Component } from '@angular/core';
import { Inspection, Person } from '../../../shared/models';
import { PluginComponent } from '../../plugin.component';
import { InstallationBobstContactPluginService } from './bobst-contact.service';

@Component({
    templateUrl: './bobst-contact.component.html',
    standalone: false
})
export class InstallationBobstContactPluginComponent {
  inspection: Inspection;
  config: any;
  technicien: Person;
  public editRoute = ['installation', 'bobstcontact', 'edit'];

  constructor(private cdRef: ChangeDetectorRef, private service: InstallationBobstContactPluginService) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.inspection = inspection;
    this.initTechnicien();
    this.cdRef.detectChanges();
  }

  initTechnicien() {
    if (this.config.TechnicienId) {
      this.service.getPerson(this.config.TechnicienId).subscribe((person) => {
        this.technicien = person;
      });
    }
  }
}
PluginComponent.plugins['installationbobstcontact'] = InstallationBobstContactPluginComponent;
